(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-vintage-notice"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cart-vintage-notice')) {
    customElements.define(
      'cart-vintage-notice',
      class CartVintageNotice extends HTMLElement {
        connectedCallback() {
          this.checkbox = this.querySelector('[data-vintage-notice-checkbox]');
          this.errorMessage = this.querySelector('[data-vintage-notice-error]');

          if (!this.checkbox) return;

          this.checkbox.addEventListener('change', this.handleChange);
        }

        disconnectedCallback() {
          if (!this.checkbox) return;

          this.checkbox.removeEventListener('change', this.handleChange);
        }

        handleChange = async (event) => {
          const checkbox = event.currentTarget;
          const requestedState = checkbox.checked;
          const matchingCheckboxes = document.querySelectorAll('[data-vintage-notice-checkbox]');

          matchingCheckboxes.forEach((item) => {
            item.disabled = true;
          });

          this.errorMessage.hidden = true;
          this.errorMessage.textContent = '';

          try {
            const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
              },
              body: JSON.stringify({
                attributes: {
                  Jahrgangsabweichung: requestedState ? checkbox.value : '',
                },
              }),
            });

            if (!response.ok) {
              throw new Error('Cart attribute could not be updated');
            }

            matchingCheckboxes.forEach((item) => {
              item.checked = requestedState;
            });
          } catch (error) {
            checkbox.checked = !requestedState;
            this.errorMessage.textContent = this.dataset.errorMessage;
            this.errorMessage.hidden = false;
          } finally {
            matchingCheckboxes.forEach((item) => {
              item.disabled = false;
            });
          }
        };
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
